import NoSleep from 'nosleep.js';
import React, { useEffect } from 'react';

interface IEventsContext {
  init: () => void;
  stop: () => void;
}

const EventsContext = React.createContext<IEventsContext>(null as never);

export default ({ children }) => {
  const noSleep = new NoSleep();

  const init = () => {
    window.addEventListener('beforeunload', beforeunloadMsg);
    window.addEventListener('keydown', keyBindings);
    preventLockScreen(true);
  };

  const stop = () => {
    window.removeEventListener('beforeunload', beforeunloadMsg);
    window.removeEventListener('keydown', keyBindings);
    preventLockScreen(false);
  };

  const beforeunloadMsg = (e) => {
    const msg = 'Você esta preste a sair da assembleia, tem certeza?';
    e.preventDefault();
    (e || window.event).returnValue = msg;
    return msg;
  };

  const preventLockScreen = (active: boolean) => {
    try {
      if (active) {
        noSleep.enable();
      } else {
        noSleep.disable();
      }
    } catch {}
  };

  const keyBindings = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.code === 'Space') {
      window.location.reload();
    }
  };

  useEffect(() => {
    init();
    return () => stop();
  }, []);

  return (
    <EventsContext.Provider value={{ init, stop }}>
      {children}
    </EventsContext.Provider>
  );
};

export function useEvents() {
  return React.useContext(EventsContext);
}
